<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          Detect
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Detect</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <div v-else>
      <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <b-row>
            <b-col>
              <strong>Detect Information</strong>
              <span class="float-right" style="font-size: 13px">Detect Time {{model.created_at | sdate}}</span>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>Agent</div>
                <div title="" v-if="model && model.agent">
                  {{model.agent.name}}
                  <span v-if="model.agent.name != model.agent.host">
                    ({{model.agent.host}})
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IP Address(Public)</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_public}}</div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IP Address(Private)</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_private}}</div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <table class="text-center h5">
            <tbody class="h6">
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="Displays the detected time">
                    Detect time
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </td>
                <td class="p-2">{{model.created_at | datetime}}</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="Shows whether to quarantine">
                    Isolation(backup)
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </td>
                <td class="p-2 text-danger font-weight-bold">{{model.is_backup ? `Yes` : `No`}}</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="Displays the classification of detected policies">
                    Pollicy
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </td>
                <td class="p-2">{{model && model.description ? model.description.type : '-'}}</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="Displays the code of the detected policy as a basis for detection">
                    basis for detection
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </td>
                <td class="p-2">{{model && model.description ? model.description.code : '-'}}</td>
              </tr>
              <tr>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="Regular expression, URL policy to display data when detected">
                  Evidence of detection data (file contents)
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <td class="p-2" v-if="model && model.description && model.description.value">{{ model.description.value || '-'}}</td>
                <td class="p-2" v-else>-</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="Displays the number of lines in the detected portion of the file">
                    Line
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </td>
                <td class="p-2" v-if="model && model.description">{{model.description.numerical > 0 ? model.description.numerical : '-'}}</td>
                <td class="p-2" v-else>-</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <b-button size="sm" class="float-left" variant="info" @click="agent"> To agent({{agentName}})</b-button>
          <!-- <b-button size="sm" class="float-left ml-2" variant="info" @click="result"> To Result </b-button> -->
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>
    <Result v-if="model.result" :result_data="model.result" />
    </div>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
